import {
	CREATED as CREATED_,
	NO_CONTENT as NO_CONTENT_,
	BAD_REQUEST as BAD_REQUEST_,
	UNAUTHORIZED as UNAUTHORIZED_,
	FORBIDDEN as FORBIDDEN_,
	NOT_FOUND as NOT_FOUND_,
	PROXY_AUTHENTICATION_REQUIRED as PROXY_AUTHENTICATION_REQUIRED_,
	REQUEST_TIMEOUT as REQUEST_TIMEOUT_,
	CONFLICT as CONFLICT_,
	PRECONDITION_FAILED as PRECONDITION_FAILED_,
	CONTENT_TOO_LARGE as CONTENT_TOO_LARGE_,
	UNPROCESSABLE_ENTITY as UNPROCESSABLE_ENTITY_,
	UPGRADE_REQUIRED as UPGRADE_REQUIRED_,
	TOO_MANY_REQUESTS as TOO_MANY_REQUESTS_,
	INTERNAL_SERVER_ERROR as INTERNAL_SERVER_ERROR_,
	BAD_GATEWAY as BAD_GATEWAY_,
	SERVICE_UNAVAILABLE as SERVICE_UNAVAILABLE_,
	GATEWAY_TIMEOUT as GATEWAY_TIMEOUT_,
} from '@jira/platform__http-status-codes/src/http-status-codes.tsx';

/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const CREATED = CREATED_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const NO_CONTENT = NO_CONTENT_;

/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const BAD_REQUEST = BAD_REQUEST_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const UNAUTHORIZED = UNAUTHORIZED_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const FORBIDDEN = FORBIDDEN_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const NOT_FOUND = NOT_FOUND_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const PROXY_AUTHENTICATION_REQUIRED = PROXY_AUTHENTICATION_REQUIRED_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const REQUEST_TIMEOUT = REQUEST_TIMEOUT_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const CONFLICT = CONFLICT_;

/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const PRECONDITION_FAILED = PRECONDITION_FAILED_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const CONTENT_TOO_LARGE = CONTENT_TOO_LARGE_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const UNPROCESSABLE_ENTITY = UNPROCESSABLE_ENTITY_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const UPGRADE_REQUIRED = UPGRADE_REQUIRED_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const TOO_MANY_REQUESTS = TOO_MANY_REQUESTS_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const INTERNAL_SERVER_ERROR = INTERNAL_SERVER_ERROR_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const BAD_GATEWAY = BAD_GATEWAY_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const SERVICE_UNAVAILABLE = SERVICE_UNAVAILABLE_;
/**
 * @deprecated Use `@jira/platform__http-status-codes/src/http-status-codes.tsx` instead.
 */
export const GATEWAY_TIMEOUT = GATEWAY_TIMEOUT_;
